import { render, staticRenderFns } from "./sales-volume-dialog.vue?vue&type=template&id=70e94aa4&scoped=true&"
import script from "./sales-volume-dialog.vue?vue&type=script&lang=js&"
export * from "./sales-volume-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e94aa4",
  null
  
)

export default component.exports